import React from "react";
const ThemeContext = React.createContext({
  foreground: null,
  background: null,
  accent: null,
});

export default ThemeContext;
